<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{$t('manage')}}</h6>
                                <h1 class="header-title">{{$t('Specialties')}}</h1>
                            </div>
                            <div class="col-auto">
                                <button
                                    @click="openModal({id:'SpecialtyEditModal', model:{language}})"
                                    class="btn btn-primary"
                                >{{$t('Add')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="card" data-toggle="lists">
                            <div class="card-header">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div class="row align-items-center">
                                            <div class="col-auto pr-0">
                                                <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                                                <span class="fe fe-search text-muted" v-else></span>
                                            </div>
                                            <div class="col">
                                                <input
                                                    type="search"
                                                    v-model="query"
                                                    class="form-control form-control-flush search no-glow"
                                                    :placeholder="$t('Search')"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-0 pl-4 pr-4" v-if="breadcrumbs.length>0">
                                <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
                            </div>
                            <simple-table
                                :data="specialties"
                                :loading="cdbLoading"
                                :edit="edit"
                                :deleteItem="deleteItem"
                                :hideDeleteButton="true"
                                :columns="columns"
                                :sort="sort"
                            ></simple-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <specialty-modal id="SpecialtyEditModal" :data="model"></specialty-modal>
    </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable.vue'
import SpecialtyModal from './SpecialtyModal.vue';
import { modalMixins } from '@/mixins/modal.js'
import { specialtyMixins } from '@/mixins/specialty.js'
import { mapActions, mapGetters, mapState } from 'vuex';


export default {
    props: ['icd'],
    mixins: [modalMixins, specialtyMixins],
    components: {
        SimpleTable,
        SpecialtyModal
    },
    data() {
        return {
            query: null,
            language: 'russian',
            model: {
                icdCode: this.icd
            },
            columns: [
                {
                    label: 'Name',
                    name: 'label',

                    field: (item) => {
                        if (item.label.length > 100) {
                            return item.label.substring(0, 100) + '...';
                        } else {
                            return item.label
                        }
                    },
                    subtitle: (item) => {
                        let data = [];
                        item.icd.forEach(element => {
                            data.push(element.label);
                        });;
                        let string = data.join(', ');

                        if (string.length > 100) {
                            return string.substring(0, 100) + '...';
                        } else {
                            return string
                        }
                    },
                },


            ],
            sort: '',
            breadcrumbs: [],
        }
    },

    created() {
        this.queryItems();

    },

    methods: {
        ...mapActions('cdb', ['find', 'create', 'patch', 'remove', 'get']),
        save() {
            let promise, successMessage;
            if (this.model._id) {
                promise = this.patch([this.model._id, this.model]);
                successMessage = this.$t('Item has been saved');
            } else {
                promise = this.create(this.model);
                successMessage = this.$t('Item has been created');
            }

            promise.then(result => {

                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });

            });

        },
        edit(item) {
            this.openModal({ id: 'SpecialtyEditModal', model: item });
        },
        deleteItem(item) {
            this.remove(item._id).then(data => {
                this.$toasted.global.success({
                    message: this.$t('Item has been deleted')
                });
            })
        },



    }
}
</script>
